module.exports = __webpack_public_path__ + "static/media/tempTemplate2.11d6ab35.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Templates/tempTemplate2.png
// module id = 495
// module chunks = 0